/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import Block from 'wfui-digital-core/es/Block';
import Guttered from 'wfui-digital-core/es/Guttered';
import NavigationContext from 'wfui-digital-core/es/NavigationContext';
import StageCoach from './stage-coach/StageCoach';
import Links from './link/Links';
import CopyRight from './copy-right/CopyRight';
import styles from './WFFooter.less';

var WFFooterContent = function WFFooterContent(_ref) {
  var footerConfig = _ref.footerConfig;
  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    centered: true,
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Guttered, null, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(StageCoach, null), /*#__PURE__*/React.createElement(Links, {
    links: footerConfig.sections[0].links
  }), /*#__PURE__*/React.createElement(CopyRight, null))));
};

var WFFooter = function WFFooter() {
  var _useContext = useContext(NavigationContext),
      getContainer = _useContext.getContainer;

  var footerConfig = getContainer('FOOTER');
  return footerConfig ? /*#__PURE__*/React.createElement(WFFooterContent, {
    footerConfig: footerConfig
  }) : null;
};

export default WFFooter;